// @flow

import { getSafeCheckoutPaymentOptions, type OpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getCashMethodsCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment/checkout-payment-options';

export function getSupportedCashOptions(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const checkoutPaymentOptions = getSafeCheckoutPaymentOptions(incomingPayment);

  return getCashMethodsCheckoutPaymentOptions(checkoutPaymentOptions);
}
